<template>
  <div class="wrapper wrapper-content animated fadeInRight articleList">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group">
          <label class="col-sm-2 control-label">{{$t("message.issueName") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                type="text"
                :placeholder="$t('message.issueName')"
                v-model="issueName"
                name="search"
                class="form-control input"
              />
            </div>
          </div>
          <label class="col-sm-2 control-label">{{$t("message.issueNumber") }}</label>
          <div class="col-sm-3">
            <div>
              <input
                type="text"
                :placeholder="$t('message.issueNumber')"
                v-model="issueNumber"
                name="search"
                class="form-control input"
              />
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">{{$t("message.Category") }}</label>
          <div class="col-sm-3">
            <select class="form-control" v-model="categoryId" name="categoryId">
              <option  class="ng-binding" value="">{{$t("message.All") }}</option>
              <option  class="ng-binding" v-for="category in categoryList" v-bind:value="category.id">{{category['name'+$i18n.locale]}}</option>
            </select>
          </div>
          <label class="col-sm-2 control-label">{{$t("message.subCategory") }}</label>
          <div class="col-sm-3">
            <select class="form-control" v-model="subCategoryId" name="subCategoryId">
              <option  class="ng-binding" value="">{{$t("message.All") }}</option>
              <option  class="ng-binding" v-for="subCategory in subCategoryList" v-bind:value="subCategory.id">{{subCategory.name}}</option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-2 control-label">
            {{$t("message.Status") }} 
          </label>
          <div class="col-sm-3">
            <div>
              <select class="form-control" v-model="status" name="status">
                <option  value="">{{$t("message.All") }}</option>
                <option value="0" class="ng-binding">{{$t("message.Draft") }} </option>
                <option value="1" class="ng-binding">{{$t("message.Ready to Publish") }}</option>
                <option value="10" class="ng-binding">{{$t("message.Published") }}</option>
              </select>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <button class="btn btn btn-primary" @click="search">{{$t("message.Search") }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive">
              <div class="col-xs-12">{{rows.length}}{{$t("message.datagridresult") }}</div>
              <datatable :columns="columns" :data="rows">
                <template scope="{ row }">
                  <tr @dblclick="datataleCli(row)" :style="trStyle">
                    <td align="center">
                      <select-row :row="row"></select-row>
                    </td>
                    <td>
                      <span>{{row['title'+$i18n.locale]}}</span>
                    </td>
                    <td>
                      <span>{{row['issueName'+$i18n.locale]}}</span>
                    </td>
                    <td>
                      <span>{{row.issueNumber}}</span>
                    </td>
                    <td>
                      <span>{{row['subCategory'+$i18n.locale]}}</span>
                    </td>
                    <td>
                      <span>{{row.statusName}}</span>
                    </td>
                    <td>
                      <span>{{row.createdTime}}</span>
                    </td>
                    <td>
                      <div class="listBtn">
                        <button type="button" v-if="row.status == 1&&checkPermission('ARTICLE_PUBLISH')" class="btn btn-primary" @click="publishEvent(row)">{{$t("message.Publish") }}</button>
                        <button type="button" v-if="row.status != 10" class="btn btn-success" @click="previewEvent(row)">{{$t("message.Preview") }}</button>
                        <button type="button" v-if="row.status == 0&&checkPermission('ARTICLE_READY_TO_PUBLISH')" class="btn btn-warning" @click="readyToPublishEvent(row)">{{$t("message.Ready to Publish") }}</button>
                        <button type="button" v-if="row.status == 10&&checkPermission('ARTICLE_OFFLINE')" class="btn btn-info" @click="editEvent(row)">{{$t("message.Edit") }}</button>
                      </div>
                    </td>
                  </tr>
                </template>
              </datatable>
              <datatable-pager
                align="right"
                :style="navStaty"
                :per-page="per_page"
                type="short"
                v-model="page"
              ></datatable-pager>
            </div>
            <div class="col-sm-12" style="margin-top:-30px;">
              <div class="pull-right">
                <button
                  class="btn btn-white"
                  @click="gotoDetail"
                >{{$t("message.Add") }}</button>
                <button class="btn btn-white" @click="showWarning">{{$t("message.Delete") }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
import selectall from "../components/common/selectAll";
import selectrow from "../components/common/selectRow";
import eventBus from "../eventbus";
import { truncate } from "fs";
import config from "../config";

export default {
  name: "usefulLinksListController",
  mixins: [config.globalMixin],
  components: {
    "select-row": selectrow,
    "select-all": selectall
  },
  data() {
    return {
      page: 1,
      per_page: 20,
      filter: "",
      superLength: 0,
      superFalg: true,
      trStyle: {
        cursor: "pointer"
      },
      navStaty: {
        "margin-top": "-30px",
        "margin-bottom": "15px",
        "margin-right": "30px"
      },
      columns: [
      ],
      rows: [
        {
          title: "",
          issueName: "",
          issueNumber: "",
          subCategory:"",
          statusName: "",
          createdTime: "",
        }
      ],
      selected_rows: [],
      searchName: "",
      searchStatus: null,
      categoryList:[],
      subCategoryList:[],
      categoryId:"",
      subCategoryId:"",
      status:"",
      issueName:"",
      issueNumber:""
    };
  },
  created: function() {
    eventBus.$on(
      "selected",
      function(row) {
        if (this.selected_rows.indexOf(row) === -1) {
          this.selected_rows.push(row);
        }
      }.bind(this)
    );

    eventBus.$on(
      "deselected",
      function(row) {
        if (this.selected_rows.indexOf(row) !== -1) {
          let index = this.selected_rows.indexOf(row);
          this.selected_rows.splice(index, 1);
        }
      }.bind(this)
    );

    eventBus.$on(
      "select-all",
      function(selected) {
        Vue.set(this, "selected_rows", this.rows.slice(0));
      }.bind(this)
    );

    eventBus.$on(
      "deselect-all",
      function(selected) {
        Vue.set(this, "selected_rows", []);
      }.bind(this)
    );
  },
  methods: {
    formatDate(value) {
      let date = new Date(value);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m;
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s;
      return d + "/" + MM + "/" + y + " " + h + ":" + m + ":" + s;
    },
    async init() {
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;
      objdata.issueName = this.issueName;
      objdata.issueNumber = this.issueNumber;
      objdata.categoryId = this.categoryId;
      objdata.subCategoryId = this.subCategoryId;
      objdata.status = this.status;
      let data = await this.$store.dispatch("getArticleList", this.setFormData(objdata));
      let list = null;
      for(var i=0;i<data.data.resultList.length;i++){
        for(var j=0;j<data.data.resultList[i].langMap.length;j++){
          if(data.data.resultList[i].langMap[j].langCode=="en_US"){
            data.data.resultList[i]['title'+'en_US'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['title'+'zh_HK'] = data.data.resultList[i].langMap[j].title;
          }
          if(data.data.resultList[i].langMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['title'+'zh_CN'] = data.data.resultList[i].langMap[j].title;
          }
        }
        for(var j=0;j<data.data.resultList[i].magazineLangMap.length;j++){
          if(data.data.resultList[i].magazineLangMap[j].langCode=="en_US"){
            data.data.resultList[i]['issueName'+'en_US'] = data.data.resultList[i].magazineLangMap[j].title;
          }
          if(data.data.resultList[i].magazineLangMap[j].langCode=="zh_HK"){
            data.data.resultList[i]['issueName'+'zh_HK'] = data.data.resultList[i].magazineLangMap[j].title;
          }
          if(data.data.resultList[i].magazineLangMap[j].langCode=="zh_CN"){
            data.data.resultList[i]['issueName'+'zh_CN'] = data.data.resultList[i].magazineLangMap[j].title;
          }
        }
        if(data.data.resultList[i].subCategoryList.length>0){
          for(var j=0;j<data.data.resultList[i].subCategoryList[0].langMap.length;j++){
            if(data.data.resultList[i].subCategoryList[0].langMap[j].langCode=="en_US"){
              data.data.resultList[i]['subCategory'+'en_US'] = data.data.resultList[i].subCategoryList[0].langMap[j].name;
            }
            if(data.data.resultList[i].subCategoryList[0].langMap[j].langCode=="zh_HK"){
              data.data.resultList[i]['subCategory'+'zh_HK'] = data.data.resultList[i].subCategoryList[0].langMap[j].name;
            }
            if(data.data.resultList[i].subCategoryList[0].langMap[j].langCode=="zh_CN"){
              data.data.resultList[i]['subCategory'+'zh_CN'] = data.data.resultList[i].subCategoryList[0].langMap[j].name;
            }
          }
        }
      }
      for (list of data.data.resultList) {
        if (list.status == 0) {
          list.statusName = this.$i18n.t("message.Draft");
        } else if (list.status == 1){
          list.statusName = this.$i18n.t("message.Ready to Publish");
        }else if (list.status == 10){
          list.statusName = this.$i18n.t("message.Published");
        }else{
          list.statusName = list.status;
        }
      }
      this.rows = data.data.resultList;
      this.getCategoryList();
    },
    async getSubCategoryList() {
      let objdata = this.getAuthObj;
      objdata.sortField = 'id';
      objdata.sortType = "ASC";
      objdata.startRow = 0;
      objdata.maxRows = 10000;
      objdata.subCategoryName = this.searchName;
      objdata.categoryId = this.categoryId;
      let data = await this.$store.dispatch("getSubCategoryList", this.setFormData(objdata));
      let list = null;
      for(var i=0;i<data.data.result.length;i++){
        for(var j=0;j<data.data.result[i].langMap.length;j++){
          if(data.data.result[i].langMap[j].langCode=="en_US"){
            data.data.result[i].nameEN = data.data.result[i].langMap[j].name;
          }
          if(data.data.result[i].langMap[j].langCode=="zh_HK"){
            data.data.result[i].nameHK = data.data.result[i].langMap[j].name;
          }
          if(data.data.result[i].langMap[j].langCode=="zh_CN"){
            data.data.result[i].nameCN = data.data.result[i].langMap[j].name;
          }
        }
      }
      this.$set(this, "subCategoryList", data.data.result);
    },
    async getCategoryList(){
        let obj = this.getAuthObj;
        let data = await this.$store.dispatch("getCategoryList", this.setFormData(obj));
        
        for(var i=0;i<data.data.result.length;i++){
          for(var j=0;j<data.data.result[i].langMap.length;j++){
            if(data.data.result[i].langMap[j].langCode=="en_US"){
              data.data.result[i]['name'+'en_US'] = data.data.result[i].langMap[j].name;
            }
            if(data.data.result[i].langMap[j].langCode=="zh_HK"){
              data.data.result[i]['name'+'zh_HK'] = data.data.result[i].langMap[j].name;
            }
            if(data.data.result[i].langMap[j].langCode=="zh_CN"){
              data.data.result[i]['name'+'zh_CN'] = data.data.result[i].langMap[j].name;
            }
          }
        }
        this.$set(this, "categoryList", data.data.result);
    },
    gotoDetail() {
      let userInfo = this.$store.state.userInfo;
      this.$router.push({ path: "/main/articleDetail" });
    },
    datataleCli(row) {
      this.$router.push({
        path: "/main/articleDetail",
        query: { id: row.id }
      });
    },
    getStatus(data) {
      if (data.indexOf("all") < 0) {
        this.searchStatus = Number(data);
      } else {
        this.searchStatus = null;
      }
    },
    async search() {
      this.init();
    },
    showWarning() {
      var that = this;
      if (this.selected_rows.length != 0) {
        // if (this.selected_rows.length == this.rows.length) {
        //   this.$store.commit("setwarning", {
        //     string: "Always keep at least 1 Publisher",
        //     boolean: true,
        //     button: [{
        //       name:this.$i18n.t("message.Cancel"),
        //       callBack:function(){}
        //     }]
        //   });
        // } else {
          this.$store.commit("setwarning", {
            string: this.$i18n.t("message.deleteContent"),
            boolean: true,
            button: [{
              name:this.$i18n.t("message.Confirm"),
              callBack:function(){
                that.deleteList();
              }
            }, {
              name:this.$i18n.t("message.Cancel"),
              callBack:function(){
                that.$store.commit("setwarning", {
                  string: "",
                  boolean: false,
                });                
              }
            }]
          });
        // }
      }
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj;
      if (this.selected_rows.length != 0) {
        for (let i = 0; i < this.selected_rows.length; i++) {
          ids.push(this.selected_rows[i].id);
        }
      }
      objdata.articleIds = ids;

      let data = await this.$store.dispatch("deleteArticle", this.setFormData(objdata));
      if (data.data.errorCode === 0) {
        this.selected_rows=[]
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    cancel: function() {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    async publish(row){
      var that = this;
      let objdata = that.getAuthObj;
      objdata.articleIds = row.id;
      let data = await that.$store.dispatch("publishArticle", that.setFormData(objdata));
      if(data){
        row.statusName = this.$i18n.t("message.Published");
        row.status = 10;
      }
    },
    async publishEvent(row){
      var that = this;
      this.$store.commit("setwarning", {
        string: this.$i18n.t("message.Are you sure to publish"),
        boolean: true,
        button: [{
            name:this.$i18n.t("message.Confirm"),
            callBack:function(){
              that.publish(row);
            }
          }, {
            name:this.$i18n.t("message.Cancel"),
            callBack:function(){
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });              
            }
          }]
      });
    },
    async previewEvent(row){
      var rnd = Date.now();
      this.$store.commit("setmagazine", {
        id: row.id,
        rnd:rnd,
        boolean: true,
      });
    },
    async readyToPublish(row){
      var that = this;
      let objdata = that.getAuthObj;
      objdata.articleIds = row.id;
      let data = await that.$store.dispatch("readyToPublishArticle", that.setFormData(objdata));
      if(data){
        row.statusName = this.$i18n.t("message.Ready to Publish");
        row.status = 1;
      }
    },
    async readyToPublishEvent(row){
      var that = this;
      this.$store.commit("setwarning", {
        string: this.$i18n.t("message.Are you sure to readyToPublish"),
        boolean: true,
        button: [{
            name:this.$i18n.t("message.Confirm"),
            callBack:function(){
              that.readyToPublish(row);
            }
          }, {
            name:this.$i18n.t("message.Cancel"),
            callBack:function(){
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            }
          }]
      });
    },
    async edit(row){
      var that = this;
      let objdata = that.getAuthObj;
      objdata.articleIds = row.id;
      let data = await that.$store.dispatch("offlineArticle", that.setFormData(objdata));
      if(data){
        row.statusName = this.$i18n.t("message.Draft");
        row.status = 0;
      }
    },
    async editEvent(row){
      var that = this;
      this.$store.commit("setwarning", {
        string: this.$i18n.t("message.Are you sure to edit"),
        boolean: true,
        button: [{
            name:this.$i18n.t("message.Confirm"),
            callBack:function(){
              that.edit(row)
            }
          }, {
            name:this.$i18n.t("message.Cancel"),
            callBack:function(){
              that.$store.commit("setwarning", {
                string: "",
                boolean: false,
              });
            }
          }]
      });
    },
    setColumns:function(){
      this.columns = [
        {
          label: "",
          align: "center",
          component: selectrow,
          headerComponent: selectall
        },
        { label: this.$i18n.t("message.Article title"), field: "title"+this.$i18n.locale },
        { label: this.$i18n.t("message.issueName"), field: "issueName"+this.$i18n.locale },
        { label: this.$i18n.t("message.issueNumber"), field: "issueNumber" },
        { label: this.$i18n.t("message.subCategory"), field: "subCategory"+this.$i18n.locale },
        { label: this.$i18n.t("message.Status"), field: "statusName" },
        { label: this.$i18n.t("message.createdTime"), field: "createdTime" },
      ]
    }


  },
  mounted() {
    this.setColumns();
    this.init();
  },
  computed:{
      _language(){
        return this.$store.state.userInfo.langCode
      }
  },
  watch: {
    selected_rows: function() {
      for (var row of this.rows) {
        if (this.selected_rows.indexOf(row) === -1) {
          return;
        }
      }
      eventBus.$emit("all-selected");
    },
    _language:function(){
      this.setColumns();
    }
  }
};
</script>

<style scoped>
.ui-grid-icon-ok:before {
  content: "\c362";
}
.ui-grid-icon:before,
.ui-grid-icon:before {
  font-family: "ui-grid";
  font-style: normal;
  font-weight: normal;
  speak: none;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  font-variant: normal;
  text-transform: none;
  line-height: 1em;
  margin-left: 0.2em;
}
</style>